import { render, staticRenderFns } from "./IndiceDeHomaIR.vue?vue&type=template&id=3bd346b7"
import script from "./IndiceDeHomaIR.vue?vue&type=script&lang=js"
export * from "./IndiceDeHomaIR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports